import { Injectable } from '@angular/core';
import { TScanLockDetails } from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class BluetoothCommonService {
  constructor() {}

  private scanLockDetails: TScanLockDetails = {
    source: '',
    isLocked: false,
  };

  setScanLockDetails(details: TScanLockDetails) {
    this.scanLockDetails = details;
  }

  getScanLockDetails() {
    return this.scanLockDetails;
  }
}
